"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _user = require("@/api/user");
var _loop = require("@/api/loop");
var _utils = require("@/utils");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LoopIndex',
  components: {
    SearchBox: _index.default
  },
  filters: {
    getInternalTitle(value) {
      return typeof value === 'undefined' ? '' : value.title;
    },
    getTenantLabel: _utils.getTenantLabel,
    getProducerStaff(value, staffList) {
      const plist = _lodash.default.map(_lodash.default.flatten(_lodash.default.map(_lodash.default.filter(value, {
        role: 'manager'
      }), function (p) {
        return _lodash.default.filter(staffList, {
          user: p.user
        });
      })), function (n) {
        return n.name;
      }).toString();
      return plist;
    }
  },
  mixins: [_autoTableHeight.autoTableHeight],
  data() {
    return {
      tableLoading: false,
      copyDrawer: false,
      total: 0,
      trainingStatus: _lifehikesInitData.trainingStatus,
      loopList: [],
      staffList: [],
      query: {
        page: 1,
        limit: 50,
        sort: '-start.utc',
        q: undefined,
        publish: undefined,
        staffUuid: undefined,
        staffRole: undefined
      },
      checked: {
        drawTitle: '',
        id: '',
        genneralInfo: true,
        salesForce: true,
        eventTime: true,
        welcomeResourceSetting: true,
        programs: true,
        staffs: true,
        emailSettings: true
      }
    };
  },
  async created() {
    await this.getStaffList();
    await this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      this.query.publish = this.query.publish === '' ? undefined : this.query.publish;
      this.getList();
    },
    deleteLoop(id, title) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      var updatedPublishStatus = {
        id: id,
        publish: 'markdelete'
      };
      this.$confirm(`This will delete [ ${title} ]. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        var data = {
          publish: 'markdelete'
        };
        (0, _loop.updateLoopById)(token, id, data).then(response => {
          this.search(this.query.page);
          const msg = 'Loop is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Loop', `${_lifehikesInitData.userEvent.loop.delete}`, oEmail, `Loop Id: ${id}`);
        }).catch(error => {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      // Open loading after API interconnection
      // this.tableLoading = true

      (0, _log.showDebugLog)('Loop query', this.query);
      (0, _loop.getLoopList)(token, this.query).then(response => {
        (0, _log.showDebugLog)('Loop-Search-response', response);
        this.loopList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('loop-Search-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    getStaffList() {
      this.loading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 100,
        role: 'otr-digital-producer',
        sort: 'givenName'
        // timestamp:new Date().getTime()
      };
      (0, _user.getUserList)(token, query).then(response => {
        this.loading = false;
        this.staffList = response.data.rows.map(s => {
          return {
            user: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });

        // console.log('Staff List', this.staffList)
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    setMyTraining() {
      if (this.query.staffUuid) {
        this.query.staffRole = 'producer';
        // this.query.staffUuid = uuid
      } else {
        this.query.staffRole = undefined;
        this.query.staffUuid = undefined;
      }
    },
    isExipred(endUtc) {
      var now = _moment.default.utc();
      var end = _moment.default.utc(endUtc);
      return now > end;
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      if (prop === 'type') {
        order === 'ascending' ? this.query.sort = '+type' : this.query.sort = '-type';
      }
      this.search(1);
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    disableVisble(id) {
      // console.info(this.$refs[id]);
      this.$refs[id].visible = false;
    },
    handleDrawClose(done) {
      this.$confirm('Are you sure you want to stop copy?').then(_ => {
        done();
      }).catch(_ => {});
    },
    openDrawer(id, title) {
      this.copyDrawer = true;
      this.checked.drawTitle = `Copy a New Loop from [${title} (${id})]`;
      this.checked.id = id;
    },
    copy() {
      this.copyDrawer = false;
      var link = `/loop/createfromcopy?` + `fromId=${this.checked.id}&` + `gi=${this.checked.genneralInfo}&` + `sf=${this.checked.salesForce}&` + `et=${this.checked.eventTime}&` + `wrs=${this.checked.welcomeResourceSetting}&` + `p=${this.checked.programs}&` + `s=${this.checked.staffs}&` + `es=${this.checked.emailSettings}`;
      this.$router.push(link);
    }
  }
};